import {
    getLeadMatches,
    getPropertyMatches,
    getPropHuntPropertyLeads,
    recomputeLeadMatches,
    refreshPropertyMatches,
} from '../utils/crmApi';

const normalizeMatches = (data) => {
    const results = data?.results || data?.items || data?.matches || [];
    return {
        ...data,
        results,
        totalCandidates: data?.totalCandidates ?? results.length,
    };
};

export async function fetchMatchesForLead(leadId, params = {}) {
    const data = await getLeadMatches(leadId, params);
    return normalizeMatches(data);
}

export async function refreshMatchesForLead(leadId) {
    const data = await recomputeLeadMatches(leadId);
    return normalizeMatches(data);
}

export async function fetchMatchesForProperty(propertyId, params = {}) {
    const data = await getPropertyMatches(propertyId, params);
    return normalizeMatches(data);
}

export async function refreshMatchesForProperty(propertyId) {
    const data = await refreshPropertyMatches(propertyId);
    return normalizeMatches(data);
}

const normalizePropHuntLead = (lead, index = 0) => {
    const id = lead?.id || lead?._id || `prophunt_${index + 1}`;
    const name = lead?.name || lead?.userName || 'Unnamed Prospect';
    const phone = lead?.phone || lead?.mobile || lead?.contact?.phone || null;
    const email = lead?.email || lead?.contact?.email || null;
    const count = Number(lead?.count || lead?.matchCount || lead?.matches || 0) || 0;
    const score = Number(lead?.matchPercentage || lead?.score || (count > 0 ? Math.min(count * 10, 100) : 0)) || 0;

    return {
        leadId: `prophunt:${id}`,
        score,
        reasons: count > 0 ? [{ label: `${count} matching requirement${count > 1 ? 's' : ''}` }] : [],
        leadSnapshot: {
            id: null,
            name,
            phone,
            email,
            status: 'Prophunt',
        },
        activitySummary: {
            contacted: false,
            overdueCount: 0,
            lastActivityLabel: 'PropHunt lead',
            nextFollowUpAt: null,
        },
        breakdown: {
            intentStatus: 'unknown',
            intentValue: '',
        },
        prophuntLead: {
            ...lead,
            source: 'prophunt',
            count,
            score,
        },
    };
};

const normalizePropHuntMatches = (data) => {
    const raw = data?.results || data?.items || data?.matches || data?.prospects || [];
    const results = raw.map((lead, index) => normalizePropHuntLead(lead, index));
    return {
        ...data,
        results,
        items: results,
        matches: results,
        totalCandidates: data?.totalCandidates ?? results.length,
    };
};

export async function fetchPropHuntLeadsForProperty(propertyId, params = {}) {
    const data = await getPropHuntPropertyLeads(propertyId, params);
    return normalizePropHuntMatches(data);
}
